import React, { useEffect, useRef } from 'react';
import { useField } from '@unform/core';
import './Textarea.scss';

export default function Textarea({ name, placeholder, rows, cols, ...rest}) {
    const inputRef = useRef(null);
    const { fieldName, defaultValue = '', registerField, error } = useField(name);

    useEffect(() => {
        registerField({
            name: fieldName,
            ref: inputRef.current,
            path: 'value',
        });
    }, [fieldName, registerField]);

    return (
        <>
            <textarea
                ref={inputRef}
                defaultValue={defaultValue}
                placeholder={placeholder}
                row={rows} cols={cols}
                className={`form__control ${error ? 'form__control--has-error' : ''}`}
                {...rest}
            ></textarea>

            { error && <span className="form__error">{error}</span>}
        </>
    );
}